export default __webpack_public_path__ + "static/media/man1.e34dcbe8.png";